var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRewardStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_846_248)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9894 29.6942C11.536 29.6942 6.28467 24.4428 6.28467 17.9894C6.28467 11.536 11.536 6.28467 17.9894 6.28467C24.4428 6.28467 29.6942 11.536 29.6942 17.9894C29.6942 24.4428 24.4428 29.6942 17.9894 29.6942Z",
    fill: "#895aef"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9895 4.51318C17.6942 4.51318 17.4412 4.2812 17.4412 3.96485V0.54833C17.4412 0.253076 17.6942 0 17.9895 0C18.3058 0 18.5378 0.253076 18.5378 0.54833V3.96485C18.5378 4.2812 18.3058 4.51318 17.9895 4.51318Z",
    fill: "#895aef"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.0123 6.3901C24.9068 6.3901 24.8225 6.36901 24.7381 6.32683C24.4639 6.1792 24.3796 5.84177 24.5272 5.58869L26.2566 2.61505C26.4042 2.34089 26.7416 2.25653 26.9947 2.40416C27.2478 2.55178 27.3532 2.88922 27.1845 3.16338L25.4762 6.11593C25.3708 6.30574 25.2021 6.3901 25.0123 6.3901Z",
    fill: "#895aef"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.1371 11.5359C29.9473 11.5359 29.7575 11.4305 29.6731 11.2618C29.5255 10.9876 29.6098 10.6713 29.8629 10.5026L32.8366 8.79429C33.0896 8.64666 33.4271 8.73102 33.5747 9.00519C33.7223 9.25826 33.638 9.5957 33.3849 9.74333L30.4112 11.4516C30.3269 11.5149 30.2425 11.5359 30.1371 11.5359Z",
    fill: "#895aef"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.4516 18.5378H32.014C31.7188 18.5378 31.4657 18.3058 31.4657 17.9895C31.4657 17.6942 31.7188 17.4412 32.014 17.4412H35.4516C35.7469 17.4412 36 17.6942 36 17.9895C36 18.3058 35.7469 18.5378 35.4516 18.5378Z",
    fill: "#895aef"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.1107 27.2689C33.0053 27.2689 32.9209 27.2478 32.8366 27.1845L29.8629 25.4762C29.6098 25.3286 29.5255 24.9912 29.6731 24.7381C29.8207 24.4639 30.1582 24.3796 30.4112 24.5272L33.3849 26.2566C33.638 26.4042 33.7223 26.7416 33.5747 26.9947C33.4903 27.1634 33.3005 27.2689 33.1107 27.2689Z",
    fill: "#895aef"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.7205 33.6592C26.5307 33.6592 26.3409 33.5537 26.2566 33.385L24.5272 30.4114C24.3796 30.1583 24.4639 29.8209 24.7381 29.6732C24.9912 29.5256 25.3286 29.61 25.4762 29.863L27.1845 32.8367C27.3532 33.0897 27.2478 33.4272 26.9947 33.5748C26.9103 33.6381 26.8049 33.6592 26.7205 33.6592Z",
    fill: "#895aef"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9895 36.0001C17.6942 36.0001 17.4412 35.747 17.4412 35.4518V32.0142C17.4412 31.7189 17.6942 31.4658 17.9895 31.4658C18.3058 31.4658 18.5378 31.7189 18.5378 32.0142V35.4518C18.5378 35.747 18.3058 36.0001 17.9895 36.0001Z",
    fill: "#895aef"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.27948 33.659C9.17403 33.659 9.08967 33.6379 9.00531 33.5747C8.73115 33.427 8.64679 33.0896 8.79441 32.8365L10.5027 29.8629C10.6714 29.6098 10.9877 29.5044 11.2619 29.6731C11.515 29.8207 11.5993 30.1581 11.4517 30.4112L9.74345 33.3849C9.638 33.5536 9.46928 33.659 9.27948 33.659Z",
    fill: "#895aef"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.88934 27.2689C2.69953 27.2689 2.50973 27.1634 2.40428 26.9947C2.25665 26.7416 2.34101 26.4042 2.61517 26.2566L5.58881 24.5272C5.84189 24.3796 6.17932 24.4639 6.32695 24.7381C6.47458 24.9912 6.39022 25.3286 6.13714 25.4762L3.1635 27.1845C3.07915 27.2478 2.9737 27.2689 2.88934 27.2689Z",
    fill: "#895aef"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.96485 18.5378H0.54833C0.253076 18.5378 0 18.3058 0 17.9895C0 17.6942 0.253076 17.4412 0.54833 17.4412H3.96485C4.2812 17.4412 4.51318 17.6942 4.51318 17.9895C4.51318 18.3058 4.2812 18.5378 3.96485 18.5378Z",
    fill: "#895aef"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.86298 11.5359C5.75753 11.5359 5.67317 11.5149 5.58881 11.4516L2.61517 9.74333C2.34101 9.5957 2.25665 9.25826 2.40428 9.00519C2.5519 8.73102 2.88934 8.64666 3.1635 8.79429L6.13714 10.5026C6.39022 10.6713 6.47458 10.9876 6.32695 11.2618C6.2215 11.4305 6.03169 11.5359 5.86298 11.5359Z",
    fill: "#895aef"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9877 6.3901C10.7979 6.3901 10.6081 6.30574 10.5027 6.13702L8.79441 3.16338C8.64679 2.88922 8.73115 2.55178 9.00531 2.40416C9.25839 2.25653 9.59582 2.34089 9.74345 2.61505L11.4517 5.58869C11.5993 5.84177 11.515 6.1792 11.2619 6.32683C11.1775 6.36901 11.0721 6.3901 10.9877 6.3901Z",
    fill: "#895aef"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.9543 24.6328C21.8911 24.6328 21.8278 24.6328 21.7645 24.5906L17.9895 23.1354L14.2355 24.5906C14.0668 24.675 13.8559 24.6328 13.7083 24.5274C13.5607 24.4219 13.4763 24.2532 13.4974 24.0634L13.7294 20.0353L11.1564 16.914C11.051 16.7664 11.0088 16.5766 11.0721 16.3868C11.1354 16.218 11.2619 16.0704 11.4517 16.0282L15.3533 15.0159L17.5466 11.5994C17.631 11.4518 17.8208 11.3674 17.9895 11.3674C18.1793 11.3674 18.348 11.4518 18.4535 11.5994L20.6468 15.0159L24.5484 16.0282C24.7171 16.0704 24.8647 16.218 24.928 16.3868C24.9912 16.5766 24.9491 16.7664 24.8225 16.914L22.2707 20.0353L22.5027 24.0634C22.5027 24.2532 22.4183 24.4219 22.2707 24.5274C22.1863 24.6117 22.0598 24.6328 21.9543 24.6328Z",
    fill: "#333333"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_846_248"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRewardStar);
export default __webpack_public_path__ + "static/media/rewardStar.bfb1e0f3e8a79bd4a4d5330edfdb2565.svg";
export { ForwardRef as ReactComponent };